import { httpClient } from './httpClient';
import { createAppUseApiHook } from '@hwm/ui-lib/core/http';

export const useApi = createAppUseApiHook(httpClient);
